import React from "react";
import { Link } from "react-router-dom";
import { 
  Building2, 
  MapPin, 
  Users, 
  Phone, 
  ChevronRight,
  Smartphone,
  Wifi,
  Package,
  Shield,
  Headphones
} from "lucide-react";
import { HomePageSEO } from "../components/SEO";
import "./HomePage.css";

export default function HomePage() {
 
  const carouselImages = [
    "store1.jpg",
    "store2.jpg",
    "store3.jpg",
    "store5.jpg",
    "store4.jpg",
    
   
  ];

  return (
    <div className="homepage">
      <HomePageSEO />
      {/* Fraud Hotline Banner */}
      <div className="fraud-banner">
        <div className="fraud-marquee">
          🚨 <strong>Fraud Hotline:</strong> Report unethical activity confidentially — 
          Call <span>069 382 1773</span> or Email <span>ops.augustco@absamail.co.za</span>
        </div>
      </div>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Your Trusted Telkom Partner</h1>
            <p className="hero-subtitle">
              Migarda Investments CC is a proud Telkom franchisee operating stores across 
              <strong> KwaZulu-Natal, Western Cape, and Northern Cape</strong>. 
              Bringing you the best in mobile, fibre, and telecommunications solutions.
            </p>
          </div>
          <div className="hero-image">
            <img src="image2.png" alt="Telkom services" />
          </div>
        </div>

        
      </section>
      {/* Moving Image Carousel */}
<div className="image-carousel-wrapper">
  <div className="image-carousel">
    {carouselImages.map((img, index) => (
      <div key={`orig-${index}`} className="carousel-image-item">
        <img src={img} alt={`Team ${index + 1}`} />
      </div>
    ))}
    {/* Duplicate for seamless loop */}
    {carouselImages.map((img, index) => (
      <div key={`dup-${index}`} className="carousel-image-item">
        <img src={img} alt={`Team ${index + 1}`} />
      </div>
    ))}
  </div>
</div>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <MapPin className="stat-icon-svg" />
              <div className="stat-number">3</div>
              <div className="stat-label">Provinces</div>
            </div>
            <div className="stat-card">
              <Building2 className="stat-icon-svg" />
              <div className="stat-number">45</div>
              <div className="stat-label">Store Locations</div>
            </div>
            <div className="stat-card">
              <Users className="stat-icon-svg" />
              <div className="stat-number">15</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-card">
              <Shield className="stat-icon-svg" />
              <div className="stat-number">100%</div>
              <div className="stat-label">Telkom Authorized</div>
            </div>
          </div>
        </div>
      </section>

      {/* Products & Services Section */}
      <section className="why-join">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Telkom Products & Services</h2>
            <p className="section-subtitle">
              Everything you need to stay connected — from mobile to fibre and beyond
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon blue">
                <Smartphone />
              </div>
              <h3 className="feature-title">Mobile Solutions</h3>
              <p className="feature-desc">
                Prepaid and contract options with the latest smartphones, data bundles, 
                and voice packages tailored to your needs.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon purple">
                <Wifi />
              </div>
              <h3 className="feature-title">Fibre Internet</h3>
              <p className="feature-desc">
                High-speed fibre connectivity for homes and businesses. 
                Uncapped options with lightning-fast speeds up to 1Gbps.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon blue">
                <Phone />
              </div>
              <h3 className="feature-title">Fixed Line Services</h3>
              <p className="feature-desc">
                Reliable landline connections with competitive call rates 
                and bundled packages for your home or office.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon blue">
                <Package />
              </div>
              <h3 className="feature-title">Business Solutions</h3>
              <p className="feature-desc">
                Enterprise connectivity, VoIP, cloud services, and dedicated support 
                for small to large businesses.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon purple">
                <Headphones />
              </div>
              <h3 className="feature-title">Customer Support</h3>
              <p className="feature-desc">
                Expert customer service at all our locations. Technical support, 
                upgrades, repairs, and account management.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Why Choose Migarda?</h2>
            <p className="cta-subtitle">
              As an authorized Telkom franchisee, we bring you the best of both worlds: 
              the quality and reliability of Telkom with personalized, local service across 45 stores.
            </p>
            <div className="cta-actions">
              <Link to="/locations" className="btn-cta-primary">
                Visit a Store
                <ChevronRight className="btn-icon" />
              </Link>
              <Link to="/contact" className="btn-cta-secondary">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Links Section */}
      <section className="quick-links">
        <div className="container">
          <div className="links-grid">
            <div className="link-card">
              <MapPin className="link-icon" />
              <h3 className="link-title">Find a Store</h3>
              <p className="link-desc">Visit any of our locations across 3 provinces</p>
              <Link to="/locations" className="link-arrow">
                View All Stores <ChevronRight className="arrow-icon" />
              </Link>
            </div>

            <div className="link-card">
              <Phone className="link-icon" />
              <h3 className="link-title">Contact Us</h3>
              <p className="link-desc">Get in touch for support or inquiries</p>
              <Link to="/contact" className="link-arrow">
                Get Help <ChevronRight className="arrow-icon" />
              </Link>
            </div>

            <div className="link-card">
              <Building2 className="link-icon" />
              <h3 className="link-title">About Migarda</h3>
              <p className="link-desc">Learn about our journey and partnership with Telkom</p>
              <Link to="/about" className="link-arrow">
                Our Story <ChevronRight className="arrow-icon" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container footer-content">
          <div className="footer-brand">
            <div>
              <img
                src="image2.png"
                alt="Migarda logo"
                className="hero-logo"
              />
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-heading">Company</h4>
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/locations" className="footer-link">Store Locations</Link>
              <Link to="/teams" className="footer-link">Our Team</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Contact</h4>
              <a href="mailto:info@migarda.co.za" className="footer-link">
                info@migarda.co.za
              </a>
              
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Legal</h4>
              <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <p className="copyright">
              © {new Date().getFullYear()} Migarda Investments CC · All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}